export default __webpack_public_path__ + "static/media/Helvetica-BoldOblique.515cc70a.ttf";